export function getProfileName() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!url) {
    return '';
  }
  var rx = /^(?:@|(?:https?:\/\/)?(?:www\.)?instagr(?:\.am|am\.com)\/)?(\w+)\/?$/;
  var match = rx.exec(url);
  if (match) {
    var profileName = match[1];
    return profileName.startsWith('@') ? profileName : "@".concat(profileName);
  }
  return '';
}